// extracted by mini-css-extract-plugin
export var active = "_32-9";
export var backButton = "_32-8";
export var clone = "_32-e";
export var collapseBar = "_32-k";
export var collapseMode = "_32-m";
export var collapsed = "_32-o";
export var dimmed = "_32-i";
export var dragHandle = "_32-c";
export var dropdownIcon = "_32-g";
export var expanding = "_32-n";
export var hidden = "_32-x";
export var iconContainer = "_32-q";
export var iconSwapper = "_32-w";
export var navItem = "_32-6";
export var navItemIcon = "_32-f";
export var navProfile = "_32-7";
export var notificationCountBadge = "_32-j";
export var notificationDot = "_32-r";
export var optionsContainer = "_32-h";
export var primaryNav = "_32-0";
export var primaryNavDivider = "_32-v";
export var primaryNavResizeHandle = "_32-2";
export var primaryNavResizing = "_32-1";
export var primaryNavTabSection = "_32-u";
export var primaryTab = "_32-p";
export var primaryTabIconBox = "_32-s";
export var secondaryNav = "_32-3";
export var selected = "_32-t";
export var settingsNav = "_32-4";
export var settingsNavItems = "_32-5";
export var show = "_32-d";
export var sideNav = "_32-l";
export var teamItem = "_32-a";
export var userProfileItem = "_32-b";